import { CONTAINER_NAME } from "../_utils/constant";
import { normalize } from "../common";
var vibrateLong = normalize(function (_ref) {
  var type = _ref.type,
      success = _ref.success,
      fail = _ref.fail,
      complete = _ref.complete;
  wx.vibrateLong({
    type: type,
    success: success,
    fail: fail,
    complete: complete
  });
}, CONTAINER_NAME.WECHAT);
export default vibrateLong;